const initCWV = () => {
    if (innerWidth <= 412) {
        improveLCP("[data-gallery-carousel] .gallery");
        improveLCP("[data-category-listing-widget] .card .image img");
        improveLCP("[data-blog-listing-widget] .card .image img");
    }
};
const improveLCP = (string) => {
    const selectorList = document.querySelectorAll(`${string}`);
    selectorList.forEach((selector) => {
        setTimeout(() => {
            selector.classList.add("active");
        }, 3000);
    });
};
